import React, { useState } from 'react';
import QuienesSomosInfo from '../components/QuienesSomosInfo'

const QuienesSomos = () => {
  return (
    <div>
      <QuienesSomosInfo />
    </div>
  );
};

export default QuienesSomos;